import React from "react";

// Reusable Navigation Button Component
export default function NavigationButton({ direction, onClick, disabled }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`p-3 rounded-full transition-all duration-300 ${
        disabled
          ? "bg-gray-800/20 text-gray-600 cursor-not-allowed"
          : "bg-gray-800/30 border border-gray-700/50 text-gray-300 hover:bg-gray-700/50 hover:text-white hover:border-violet-400/50"
      }`}
    >
      <svg
        className="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        {direction === "left" ? (
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 19l-7-7 7-7"
          />
        ) : (
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        )}
      </svg>
    </button>
  );
}
